import { AppBar, Button, Divider, Toolbar } from '@material-ui/core';
import { LoaderContext } from 'framework/context/LoaderContext';
import React, { useContext } from 'react';
import { DialogsContext } from 'shared/dialogs/DialogsContext';
import { UserButtonAndMenu } from './UserButtonAndMenu';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ColorOnHoverIconButton } from 'framework/components/buttons/ColorOnHoverIconButton';
import { TooltipWithSpan } from 'framework/components/TooltipWithSpan';
import RefreshIcon from '@material-ui/icons/Refresh';

interface IProps {
    children: any;
    onGoBack?: VoidFunction;
    backText?: string;
    onRefresh?: VoidFunction;
}

export const PageWithoutSearch = ({ children, onGoBack, backText, onRefresh }: IProps) => {
    const { stackCount } = useContext(DialogsContext);
    const { count: loadCount } = useContext(LoaderContext);

    return (
        <div className="fg1 df-col stretch-ver">
            <AppBar position="sticky" style={{ backgroundColor: 'white', boxShadow: 'none', borderBottom: '1px solid lightGray' }}>
                <Toolbar>
                    {onGoBack && <Button variant='outlined' size="small" startIcon={<ArrowBackIcon />} onClick={onGoBack}>{backText ?? `TERUG NAAR VORIGE`}</Button>}
                    <div className="fg1" style={{ height: 75 }} />
                    {process.env.NODE_ENV === `development` ? <div>Stack count: {stackCount}</div> : <div></div>}
                    {process.env.NODE_ENV === `development` ? <div>Load count: {loadCount}</div> : <div></div>}
                    {onRefresh &&
                        <>
                            <Divider orientation='vertical' />
                            <TooltipWithSpan title="Herlaad">
                                <ColorOnHoverIconButton onClick={onRefresh} style={{ marginLeft: 20, marginRight: 20 }}>
                                    <RefreshIcon />
                                </ColorOnHoverIconButton>
                            </TooltipWithSpan>
                        </>
                    }
                    <Divider orientation='vertical' />
                    <UserButtonAndMenu style={{ paddingLeft: 50, paddingRight: 50 }} />
                </Toolbar>
            </AppBar>
            <div className='fg1' style={{ padding: 20 }}>
                {children}
            </div>
        </div>
    );
}